<template>
  <div>
    <Head title="Create Contact" />
    <h1 class="mb-8 text-3xl  font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/post">Post</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input v-model="form.pltf_id" :error="form.errors.pltf_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Platform">
            <option value="1">Instagram</option>
            <option value="2">Whatsapp</option>
            <option value="3">YouTube</option>
            <option value="4">Facebook</option>
          </select-input>
        </div>
          
          <select-input v-model="form.crtr_id" :error="form.errors.crtr_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Anchor">
            <option v-for="creator in creators" :key="creator.crtr_id" :value="creator.crtr_id">
              {{ creator.crtr_name }}
            </option>
          </select-input>
          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="form-label">Stores:</label>
            <multiselect v-model="form.ers_loc_ids"
              :options="form.options"
              :multiple="true"
              track-by="id"
              label="name"
              placeholder="Select Stores"
              :close-on-select="false"
            />
            <div v-if="form.errors.ers_loc_ids" class="form-error">{{ form.errors.ers_loc_ids }}</div>
          </div>

          <text-input v-model="form.cntnt_url" :error="form.errors.cntnt_url" class="pb-8 pr-6 w-full lg:w-1/2" label="Media url" />

          <select-input v-model="form.cntnt_is_inhouse" :error="form.errors.cntnt_is_inhouse" class="pb-8 pr-6 w-full lg:w-1/5" label="Is produced In house">
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select-input>
          <select-input v-model="form.cntnt_owner" :error="form.errors.cntnt_owner" class="pb-8 pr-6 w-1/5" label="Content Owner">
            <option value="US">US</option>
            <option value="THEM">Them</option>
            <option value="BOTH">COLLAB</option>
          </select-input>
          <select-input v-model="form.cntnt_type" :error="form.errors.cntnt_type" class="pb-8 pr-6 w-1/5" label="Content Type">
            <option value="Branding">Branding</option>
            <option value="Product Promotion">Product Promotion</option>
            <option value="Offer">Offer</option>
            <option value="Review">Review</option>
            <option value="Tutorial">Tutorial</option>
            <option value="Entertainment">Entertainment</option>
          </select-input>
        
          <select-input v-model="form.cntnt_format" :error="form.errors.cntnt_format" class="pb-8 pr-6 w-1/5" label="Content Format">
            <option value="Reel">Reel</option>
            <option value="Short">Short</option>
            <option value="Post">Post</option>
            <option value="PostPost">PostPost</option>
            <option value="Video">Video</option>
          </select-input>
          <select-input v-model="form.cntnt_has_offer" :error="form.errors.cntnt_has_offer" class="pb-8 pr-6 w-full lg:w-1/5" label="Content has Offer">
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select-input>

          <div class="bg-blue-300 border border-gray-200 rounded-md p-4 mb-8 shadow-sm">
            <h3 class="text-lg font-semibold text-gray-700 mb-4">Pricing Details</h3>
            <div class="flex flex-wrap -mb-8 -mr-6">
            <text-input  v-model="form.cntnt_market_price" :error="form.errors.cntnt_market_price" class="pb-8 pr-6 w-1/5" label="Market Price" />
            <text-input v-model="form.cntnt_platform_price" :error="form.errors.cntnt_platform_price" class="pb-8 pr-6 w-1/5" label="Platform Price" />
            <text-input v-model="form.cntnt_deal_price" :error="form.errors.cntnt_deal_price" class="pb-8 pr-6 w-1/5" label="Deal price" />
            <text-input v-model="form.cntnt_crtr_charges" :error="form.errors.cntnt_crtr_charges" class="pb-8 pr-6 w-1/5" label="Content Charges" />
            <text-input v-model="form.cntnt_platform_charges" :error="form.errors.cntnt_platform_charges" class="pb-8 pr-6 w-1/5" label="Paid to Platform" />
          </div>
            
         
          <div class="pb-8 pr-6 w-full lg:w-1/5">
            <label class="form-label" :for="Barcode">Deal Barcodes:</label>
            <input
            type="radio"
            value="Barcode"
            v-model="form.deal" 
             class="pb-8 pr-6 w-full lg:w-1/2"
            />
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/5">
            <label class="form-label" :for="Barcode">Deal Custom SQL:</label>
            <input
            type="radio"
            value="SQL"
            v-model="form.deal" 
             class="pb-8 pr-6 w-full lg:w-1/2"
            />
          </div>

          <textarea-input v-if="form.deal === 'Barcode'" :rows="5" :cols="9"  v-model="form.deal_barcodes" placeholder="Ex:B0123,AB256" :error="form.errors.deal_barcodes" :type="radio" class="pb-8 pr-6 w-full "  />
          <textarea-input  v-if="form.deal === 'SQL'" :rows="5" :cols="9" v-model="form.deal_items_sql" :error="form.errors.deal_items_sql" :type="radio" class="pb-8 pr-6 w-full " placeholder="Custom SQL" />

          <div v-if="form.errors.deal_barcodes" class="form-error">{{ form.errors.deal_barcodes }}</div>
          <div v-if="form.errors.deal_items_sql" class="form-error">{{ form.errors.deal_items_sql }}</div>

        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Post</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from 'vue-multiselect'
import TextareaInput from '../../Shared/TextareaInput.vue'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Multiselect,
    TextareaInput
  },
  layout: Layout,
  props: {
    content: Array,
    creators:Array,
    options: Array,
    stores: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        pltf_id: undefined,
        crtr_id: undefined,
        ers_loc_ids:undefined,
        cntnt_url:undefined,
        cntnt_is_inhouse:undefined,
        cntnt_owner:undefined,
        cntnt_type:undefined,
        cntnt_format:undefined,
        cntnt_has_offer:undefined,
        cntnt_market_price:undefined,
        cntnt_platform_price:undefined,
        cntnt_deal_price:undefined,
        cntnt_crtr_charges:undefined,
        cntnt_platform_charges:undefined,
        deal_barcodes:undefined,
        deal_items_sql:undefined,
        options: this.stores,
      }),
     
    }
  },
  methods: {
    store() {
      this.form.post('/post')
    },
  },
}
</script>
<style scoped>
.bg-blue-300{
  background-color: rgb(147 197 253);
}
</style>